import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi, CommitmentType } from "@/services/cloudchipr.api";
import { getRecommendationFiltersPreferenceKey } from "@/store/commitments/thunks/recommendations/user-preference/getRecommendationFiltersUserPreferenceByKeyThunk";
import { CommitmentsRecommendationsFilters } from "@/store/commitments/utils/types/types";
import { commitmentsRecommendationsFiltersSelector } from "@/store/commitments/selectors/recommendations/filters/commitmentsRecommendationsFiltersSelector";
import { RootState } from "@/store/store";

interface UpdateRecommendationFiltersUserPreferenceByKeyThunkArgs {
  key: CommitmentType;
  value: Partial<CommitmentsRecommendationsFilters>;
}
export const updateRecommendationFiltersUserPreferenceByKeyThunk =
  createAsyncThunk(
    "recommendations/updateRecommendationFiltersUserPreferenceByKey",
    async (
      { key, value }: UpdateRecommendationFiltersUserPreferenceByKeyThunkArgs,
      { dispatch, getState },
    ) => {
      const state = getState() as RootState;
      const { patchUsersMeCurrentPreferenceByKey } = cloudChiprApi.endpoints;
      const data = commitmentsRecommendationsFiltersSelector(state);
      await dispatch(
        patchUsersMeCurrentPreferenceByKey.initiate({
          key: getRecommendationFiltersPreferenceKey(key),
          body: {
            value: JSON.stringify({
              ...(data ?? {}),
              ...value,
            }),
          },
        }),
      );
    },
  );
